// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"c3a07507","703":"3a8e584b","787":"2880d7a9"}[chunkId] + ".chunk.js";
};